class RegionsApi {
    static getAll() {
        return axios.get('/api/regions')
            .then(response => response.data);
    }
}

export default RegionsApi;
